import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider, useLang } from "./i18n/LanguageContext";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import About from "./components/site/About";
import Services from "./components/site/Services";
import Experience from "./components/site/Experience";
import Method from "./components/site/Method";
import Audience from "./components/site/Audience";
import Why from "./components/site/Why";
import Founder from "./components/site/Founder";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

const SeoHead = () => {
  const { lang } = useLang();
  useEffect(() => {
    if (lang === "en") {
      document.title = "ADR 4 Solutions | Corporate IT Consulting & IT Governance";
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", "ADR 4 Solutions partners with companies and complex organizations to strengthen the operational governance of service desk, end user support, IT processes, reporting and team coordination.");
    } else {
      document.title = "ADR 4 Solutions | Consulenza IT Corporate & IT Governance";
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", "ADR 4 Solutions supporta aziende e organizzazioni strutturate nella governance operativa di service desk, end user support, processi IT, reporting e coordinamento team.");
    }
  }, [lang]);
  return null;
};

const Home = () => {
  return (
    <div className="App">
      <SeoHead />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Experience />
        <Method />
        <Audience />
        <Why />
        <Founder />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0B1B33",
            color: "#FDFCF0",
            border: "1px solid rgba(197,160,89,0.3)",
            borderRadius: "0",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
